import { postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const postEventBuyButtonClicked = (data) =>
  postRequest(replaceInUrl(apiEndpoints.crmEvents.eventBuyButtonClicked, data));

export const postEventBuyFlowSteps = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.crmEvents.eventBuyFlowSteps, { accountUid }),
    data,
  );

export const postCrmEvent = (accountUid, data) =>
  postRequest(
    replaceInUrl(apiEndpoints.crmEvents.crmEvents, { accountUid }),
    data,
  );

export const postCrmEventMailinStorageStartedEvent = (data) =>
  postRequest(
    replaceInUrl(apiEndpoints.crmEvents.mailinStorageStartedEvent, data),
  );

export const postSfhJourneyStartedEvent = (data) =>
  postRequest(replaceInUrl(apiEndpoints.crmEvents.sfhJourneyStarted, data));
